export default __webpack_public_path__ + "static/media/over-axle-axlesGroup-weight.1fff2135.svg";